/* unplugin-vue-components disabled */import { render } from "./ClassStudentDetailDialog.vue?vue&type=template&id=1e987ada&scoped=true"
import script from "./ClassStudentDetailDialog.vue?vue&type=script&lang=js"
export * from "./ClassStudentDetailDialog.vue?vue&type=script&lang=js"

import "./ClassStudentDetailDialog.vue?vue&type=style&index=0&id=1e987ada&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e987ada"]])

export default __exports__